import i18next from "i18next"

import Lang_en from "./en.json"
export const initI18n = () => {
  i18next.addResourceBundle("en", "check_idle", Lang_en)
}
